import React from 'react';
import { IconButton } from '@mui/material';
export var KeyboardIconButton = function (_a) {
    var onClick = _a.onClick, children = _a.children, color = _a.color, disabled = _a.disabled, edge = _a.edge, size = _a.size, sx = _a.sx;
    return (React.createElement(IconButton, { color: color, disabled: disabled, edge: edge, size: size, onClick: onClick, sx: sx }, children));
};
//# sourceMappingURL=KeyboardIconButton.js.map